import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";

import { PriceProps } from "../../PriceProps";
import { ProductDesktopLayout, ProductMobileLayout } from "./components";

export interface ProductModalBodyContentProps {
  product: ProductDetailResponseDto;
  source: ProductDetailResponseDto["productSources"];
  platform: null | ProductSourceDtoSourceEnum;
  setPlatform: (platform: null | ProductSourceDtoSourceEnum) => void;
  reload: () => void;
  hasSubscribe?: boolean;
  isDesktop: boolean;
  priceProps: PriceProps;
}

export const ProductModalBodyContent = ({
  product,
  source,
  platform,
  setPlatform,
  hasSubscribe,
  reload,
  isDesktop,
  priceProps,
}: ProductModalBodyContentProps) => {
  return (
    <>
      {isDesktop ? (
        <ProductDesktopLayout
          product={product}
          source={source}
          platform={platform}
          reload={reload}
          setPlatform={setPlatform}
          hasSubscribe={hasSubscribe}
          isDesktop
          priceProps={priceProps}
        />
      ) : (
        <ProductMobileLayout
          product={product}
          source={source}
          platform={platform}
          reload={reload}
          setPlatform={setPlatform}
          hasSubscribe={hasSubscribe}
          priceProps={priceProps}
        />
      )}
    </>
  );
};
